import { Component, h } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'

interface Props {
  title: string
  amount: number
  period: number
  onChange: (state: {title: string, amount: number, period: number}) => void
}

interface State {
  title: string
  amount: number
  period: number
}

export class MostLikedConfigurator extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      title: props.title,
      amount: props.amount,
      period: props.period,
    }

    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeAmount = this.onChangeAmount.bind(this)
    this.onChangePeriod = this.onChangePeriod.bind(this)
  }
  
  onChangeTitle (newTitle: string) {
    this.setState({
      title: newTitle
    }, this.notifyChanges)
  }

  onChangeAmount (newAmount: number) {
    this.setState({
      amount: newAmount
    }, this.notifyChanges)
  }

  onChangePeriod (newPeriod: number) {
    this.setState({
      period: newPeriod
    }, this.notifyChanges)
  }

  notifyChanges () {
    this.props.onChange(this.state)
  }

  render (props: Props, {title, amount, period} : State) {
    return (
      <div class='most-liked-widget__configurator'>
        <InputGroup
          title='Title'
          type='text'
          qaClasses='qa-most-liked-widget__title'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
          value={title} />  
        <InputGroup
          title='Amount of users'
          type='number'
          qaClasses='qa-most-liked-widget__amount'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangeAmount(parseInt(e.target.value, 10)) }}
          value={amount}
          min={1} />
        <InputGroup
          title='Period in days'
          type='number'
          qaClasses='qa-most-liked-widget__amount'
          onChange={(e: {target: HTMLInputElement}) => { this.onChangePeriod(parseInt(e.target.value, 10)) }}
          value={period}
          min={1} />
      </div>
    )
  }
}

export default MostLikedConfigurator
